import constant from './constant';
import moment from 'moment';
import request from './request';
import COS from 'cos-js-sdk-v5';
import OSS from 'ali-oss';
import {copyText} from 'vue3-clipboard';
import { newGuid, queryString } from './base-utils';
import defaultGroupChatAvatar from '@/assets/img/defaultGroupChatAvatar.png';

export default {
	copyTextFn(text){
		copyText(text, undefined, (error) => {
			if (error) {
				console.log(`复制失败: ${error} ！`);
				this.showToast('失败了呀');
			} else {
				console.log(`复制: ${ text } 成功！`);
				this.showToast('复制成功！');
			}
		});
	},
	getStartUp(){
		return new Promise((resolve, reject) => {
			request({
				url:'/StartUp',
				method:'post',
			}).then(res => {
				// console.log('StartUp',res)
				if(res.data.code == 200){
					let data = res.data.data;
					localStorage.setItem('qx2StartUp',JSON.stringify(data));
					if(data.appDomains){ 
						request.domain.updateList(data.appDomains);
						request.domain.updateReadOnlyApis(['newapi', 'oldapi']);
					}
					var indexContentTabs = data.indexContentTabs;
					if(indexContentTabs){
						localStorage.setItem('qx2indexContentTabs',JSON.stringify(indexContentTabs));
					}
					resolve(res);
				}else{
					reject(res);
				}
			}).catch(err=>{
				reject(err);
			}).finally(() => {
				try{
					// 如果设置了IP锁定，且是http，且为IP访问，则锁定
					if (typeof window !== 'undefined' 
						&& window.location && window.location.protocol === 'http:' 
						&& window.mainbodyConfig.http_ip_api) {
						const host = window.location.hostname || '';
						if (host == "localhost" || /^\d{1,3}(\.\d{1,3}){3}$/.test(host)) {
							console.warn('锁定http ip访问的域名：', window.mainbodyConfig.http_ip_api);
							request.domain.lock(window.mainbodyConfig.http_ip_api);
						}
					}
				} catch (err) {
					console.error('lock domain check error', err);
				}
			})
		})
	},
	getSptData({ sportType, buss_type, buss_id, buss_name }) {
		return new Promise((resolve, reject) => {
			// 首先尝试从localStorage获取host
			const getHostFromStorage = () => {
				try {
					return sessionStorage.getItem('unstructuredSportDataHost');
				} catch (e) {
					console.error('从本地存储读取host失败:', e);
				}
				return null;
			};
			
			// 获取host
			const cachedHost = getHostFromStorage();
			
			if (cachedHost) {
				// 使用缓存的host
				const url = `${cachedHost}/spt/data/${sportType}/${buss_type}/${buss_id}/${buss_name}.json`;
				request({
					url,
					serv: 'custom',
					method: 'get',
					notips: true
				}).then(resolve).catch(reject);
			} else {
				// 没有缓存，重新获取startup
				this.getStartUp().then(startup => {
					if (startup.data.code === 200) {
						const host = startup.data.data.configData.unstructuredSportDataHost;
						
						// 保存host到localStorage
						try {
							localStorage.setItem('startup_host', host);
							// 或者保存完整的configData
							localStorage.setItem('startup_configData', JSON.stringify(startup.data.data.configData));
						} catch (e) {
							console.error('保存host到本地存储失败:', e);
						}
						
						const url = `${host}/spt/data/${sportType}/${buss_type}/${buss_id}/${buss_name}.json`;
						request({
							url,
							serv: 'custom',
							method: 'get'
						}).then(resolve).catch(reject);
					} else {
						reject(new Error('启动失败'));
					}
				}).catch(reject);
			}
		});
	},
	newGuid,
	// 区间随机数
	intervalRandom(min,max){
		let temp;
		if(min>max){
			temp=max;max=min;min=temp;
		}
		return Math.floor(Math.random() * (max - min) ) + min;
	},
	queryString,
	// 获得promise的状态
	decidePromiseState(promise) {
		const PROMISE_STATE = {
			PENDING: 'pending',
			FULFILLED: 'fulfilled',
			REJECTED: 'rejected'
		}
		const t = {};
		return Promise.race([promise, t]).then(v => {
			return (v === t) ? PROMISE_STATE.PENDING : PROMISE_STATE.FULFILLED
		}).catch(() => PROMISE_STATE.REJECTED);
	},
	getUserInfo(){
		return new Promise((resolve, reject) => {
			request({
				url:'/UserInfo',
				method: 'POST',
			}).then(res => {
				let user = res.data.data;
				resolve(user);
			}).catch((err)=>{
				console.log('UserInfo', err);
				reject(err);
			})
		})
	},
	routerPush(data){
		let needUserToken = ['/personal_information','/personal_anchorCenter','/personal_anchorHouseManage','/personal_mysuccess','/personal_myrecord'];
		let token = localStorage.getItem('qx2token');
		if (needUserToken.includes(data?.path) && !token) {
			// return this.mitter.emit('triggerLogin', true);
			let redirectUrl = this.$route.path;
			let query = {redirectUrl};
			let hasquery = Object.keys(this.$route.query).length>0;
			if (hasquery) {
				Object.assign(query, {redirectQuery: encodeURIComponent(JSON.stringify(this.$route.query)) });
			}
			this.routerRreplace({path:'/personal_login', query });
			
		}else{
			toNextPage.call(this);
		}
		function toNextPage() {
			let appdom = document.querySelector('#app');
			if (appdom && this.isWechat()) {
				appdom.style.setProperty('--pageHeight', `${document.documentElement.clientHeight}px`);
			}
			let {path,query} = data;
			if(path=='/personal_anchorHouseManage'){
				if (!query) {
					let qx2userInfo = JSON.parse(localStorage.getItem('qx2userInfo'));
					if(qx2userInfo.roomID){
						query = {roomID: qx2userInfo.roomID};
					}else{
						return this.showToast('您还没有开通直播间');
					}
				}
			}
			this.$router.push({path,query});
			let history = JSON.parse(localStorage.getItem('qx2vue-history')) || [];
			history.push({ path, query });
			localStorage.setItem('qx2vue-history', JSON.stringify(history));
		}
	},
	routerRreplace(data){
		let {path,query} = data;
		let history = JSON.parse(localStorage.getItem('qx2vue-history')) || [];
		// console.log(history, path, query); 
		// debugger
		if (history.length>1 && history[history.length-2].path == path) {
			return this.navBack();
		}
		this.$router.replace({path,query});
	},
	navBack(key){
		const routeStack = this.$router.currentRoute.value;
		let query = Object.assign({}, routeStack.query);
		if (query.redirectQuery) {
			console.log(query.redirectQuery);
			query.redirectQuery = decodeURIComponent(decodeURIComponent(query.redirectQuery));
			Object.assign(query, JSON.parse(query.redirectQuery));
			Reflect.deleteProperty(query, 'redirectQuery');
		}
		if ((key&&!key.length) && Object.keys(query).length>0 && Object.keys(query).find(item => item=='redirectUrl')) {
			key = 'redirectUrl';
		}
		back.call(this);
		function back() {
			if(key && routeStack.query[key]){
				Reflect.deleteProperty(query, key);
				return this.routerRreplace({path:routeStack.query[key], query });
			}
			let apphistorylength = 1; // app内嵌H5的历史记录相比H5自身会少 1 条
			let history = JSON.parse(localStorage.getItem('qx2vue-history')) || [];
			apphistorylength += history.length;
			history.splice(history.length - 1, 1);
			localStorage.setItem('qx2vue-history', JSON.stringify(history));
			apphistorylength -=1;
			console.log('history.length', history.length);
			try {
				if (!apphistorylength || apphistorylength<1) {
					if (constant?.Source==4) {
						backOff.postMessage('backRefresh');
					}else{
						this.routerRreplace({path:'/'})
					}
				}else{
					this.$router.back();
				}
			} catch (error) {
				console.log(error);
			}
		}
	},
	isIOS(){
		const ua = navigator.userAgent.toLowerCase();
		console.log('---ua', ua);
		return /iphone|ipad|ipod|ios/.test(ua);
	},
	isNotAppleDevice() {
		const ua = navigator.userAgent || '';
		// 匹配 iPhone / iPad / iPod / Macintosh
		const isApple = /(iPhone|iPad|iPod|Macintosh)/i.test(ua);
		return !isApple;
	},
	//app跳转到直播间
	openAppViewToNewPage(uriValue, data=null){
		console.log('openAppViewToNewPage', uriValue, data);
		if(constant.Source == 4) {
			let uriBase = `wbxm://wbxm.com${/^#/.test(uriValue)?'':'#'}`;
			let params = {"uriValue": encodeURIComponent(uriBase+uriValue)};
			if (data) Object.assign(params , {"data": data});
			// console.log('openAppViewToNewPage',JSON.stringify(params));
			console.log('openAppViewToNewPage',params);
			openAppView.postMessage(JSON.stringify(params));
		}
	},
	isWechat(){
		const ua = navigator.userAgent.toLowerCase();
		return /micromessenger/.test(ua);
	},
	changeConstantValue(data){
		if (Object.keys(data).length>0) {
			Object.assign(constant, data);
			console.log('---constant', constant);
		}
	},
	setVariable(){
		let appver = this.queryString('appver') || null;
		let appbarh = this.queryString('appbarh') || null;
		let navbarh = this.queryString('navbarh') || null;
		if(appbarh || navbarh || appver){
			constant.appver = appver;
			constant.statusBarHeight = appbarh;
			constant.titleBarHeight = navbarh;
			constant.Source = 4;
		}
		console.log('---isIOS()',this.isIOS());
		if (this.isWechat()) {
			constant.footerHeight = 70;
		}
		// console.log(document.documentElement.clientHeight, document.body.clientHeight, window.screen.height);
		constant.pageHeight = Math.min(document.documentElement.clientHeight, window.screen.height);
		let appdom = document.querySelector('#app');
		appdom.style.setProperty('--pageHeight', `${constant.pageHeight}px`);
		appdom.style.setProperty('--footerHeight',`${constant.footerHeight}px`);
		appdom.style.setProperty('--navHeight',`${constant.titleBarHeight}px`);
		appdom.style.setProperty('--statsHeight',`${constant.statusBarHeight}px`);


		let token = this.queryString('token') || null;
		if(token){
			localStorage.setItem('qx2token', token);
			setTimeout(() => {
				this.getUserInfo();
			}, 1);
		}
		let development = this.queryString('development') || null;
		if (development) {
			constant.development = true;
		}
		let debug = this.queryString('debug') || null;
		if (debug) {
			const vConsole = new this.VConsole();
		}

		let ver = this.queryString('ver') || null;
		if (ver) {
			constant.version_number = ver || 'Local';
		}


		// Android调用示例
		const headers = window.AndroidApp && window.AndroidApp.getHeaders();
		let acceptLanguage = null;
		if (headers) {
			acceptLanguage = JSON.parse(headers)?.["Accept-Language"];
		}
		
		// iOS调用示例
		if (!acceptLanguage) {
			acceptLanguage = window.appHeaders?.["Accept-Language"];
		}
		console.log('---acceptLanguage---app传入的语言', acceptLanguage);
		
	},
	watchVersion(){
		window.addEventListener('message', (event)=>{
			if (event.data && event.data.type == 'qx2_version_updater') {
				console.log('版本对比', constant.version_number, event.data.version);
				if (event.data.version && constant.version_number && event.data.version != constant.version_number) {
					this.showConfirmDialog({
						width: 250,
						title: '提示',
						message:'发现新版本，是否更新',
					})
					.then(() => {
						let search = document.location.search;
						if (search && search.indexOf('ver=')>-1) {
							search = search.replace(/(ver=)[^&#]+/, 'ver='+event.data.version);
						}else{
							search += `?ver=${event.data.version}`;
						}
						document.location.href = document.location.origin + document.location.pathname + search;
					})
					.catch(() => {
						console.log('用户点击了取消');
					});
				}
			}
		});
	},
	filterhotCount(data){ //转换的值, 单位, 是否四舍五入, 小数点位数
		let {value, unit, WhetherToRound, point, subset} = data;
		let result = 0;
		if(value && value>0){
			if (subset && value<10000) {
				return value;
			}
			if (unit=='k') {
				if(value>=1000){
					let toF = 0;
					if (WhetherToRound) {
						toF = (value/1000).toFixed(point);
					}else{
						toF =  (value/1000).toString();
					}
					let wvalue = toF.split('.')[0];
					let remainder = toF.split('.')[1];
					if (remainder) {
						value = wvalue +'.'+ remainder.substr(0,point) + `${unit}`;
						result = value;
					} else {
						result = wvalue + `${unit}`;
					}
				}else{
					result = value.toString().replace(/(\d)(?=(?:\d{3})+$)/g,'$1,');
				}
			}else{
				if(value>=10000){
					let toF = 0;
					if (WhetherToRound) {
						toF = (value/10000).toFixed(point);
					}else{
						toF =  (value/10000).toString();
					}
					let wvalue = toF.split('.')[0];
					let remainder = toF.split('.')[1];
					if (remainder) {
						value = wvalue +'.'+ remainder.substr(0,point) + `${unit}`;
						result = value;
					} else {
						result = wvalue + `${unit}`;
					}
				}else{
					result = value.toString().replace(/(\d)(?=(?:\d{3})+$)/g,'$1,');
				}
			}
		}
		return result;
	},
	// 上报埋点
	AddVisitRecord(data){
		let cleanData = Object.fromEntries( Object.entries(data).filter(([_, value]) => value !== undefined) );
		return new Promise((resolve, reject) => {
			request({
				url:'/AddVisitRecord',
				method:'post',
				data: cleanData,
				notips: true,
			}).then(res => {
				resolve(res);
			}).catch(err=>{
				reject(err);
			})
		})
	},
	// 用户积分活动上报
	UserActivityEvent(data){
		return new Promise((resolve, reject) => {
			let cleanData = Object.fromEntries( Object.entries(data).filter(([_, value]) => value!==undefined && value!=0) );
			if (data.code==0) {
				Object.assign(cleanData, { code: data.code });
			}
			request({
				url:'/UserActivityEvent',
				method:'post',
				data: cleanData,
				notips: true,
			}).then(res => {
				resolve(res);
			}).catch(err=>{
				reject(err);
			})
		})
	},
	// 上传文件
	uploadFile(params,file){
		return new Promise((resolve, reject) => {
			if(true){//腾讯上传
				let requestParmas = {
					url:`TXAssumeRole`,
					data:{},
					method: "post"
				}
				if(!params.custom){
					if(!file)return reject('缺少file参数');
					let defalutParmas = ['extName'];
					let _params = {};
					defalutParmas.forEach(k=>{
						if(params[k]!=undefined){
							_params[k] = params[k];
						}
					})
					requestParmas.data = _params;
				}else{
					Object.assign(requestParmas,params.data);
				}
				request(requestParmas).then(({data}) => {
					if (data && data.success || data.code == 200) {
						// 初始化COS实例
						var cosInstance = new COS({
							getAuthorization: (options, callback) => {
								callback({
									TmpSecretId: data.data.accessKeyId,
									TmpSecretKey: data.data.accessKeySecret,
									SecurityToken: data.data.securityToken,
									ExpiredTime: moment(data.data.expiration).valueOf()/1000
								});
							}
						});
						// 执行COS上传
						cosInstance.putObject({
							Bucket: data.data.bucket,
							Region: data.data.region,
							Key: data.data.objectKey,
							Body: file,
							onProgress: (progressData) => {
								params.onProgress&&params.onProgress({
									percent: progressData.percent * 100
								});
							},
						}, (err) => {
							if (err) {
							// 	throw(new Error(`上传失败: ${err.Message || '未知错误'}`));
								console.log('腾讯上传-回调err：',err);
								reject(err);
							}else{
								console.log('腾讯上传-回调：',err);
								resolve(data.data.signUrl);
							}
						})
					}else{
						reject(data.message || data.msg);
					}
				}).catch(err=>{
					reject(err);
				})
			}else{//阿里上传
				let requestParmas = {
					url:`GetAssumeRole`,
					params:{},
				}
				if(!params.custom){
					if(!file)return reject('缺少file参数');
					let defalutParmas = ['iconType','dataId','sportType','extname'];
					let _params = {};
					defalutParmas.forEach(k=>{
						if(params[k]!=undefined){
							_params[k] = params[k];
						}
					})
					requestParmas.params = _params;
				}else{
					Object.assign(requestParmas,params.data);
				}
				request(requestParmas).then(({data}) => {
					if (data && data.success) {
						let res = data.data;
						const client = new OSS({
							region: res.assumeRole.region,
							accessKeyId: res.assumeRole.accessKeyId,
							accessKeySecret: res.assumeRole.accessKeySecret,
							Expiration: res.assumeRole.rxpiration,
							UseToken: res.assumeRole.useToken,
							bucket: res.assumeRole.bucket,
							stsToken: res.assumeRole.securityToken //加上这一行，问题解决
						});
						if(!params.custom){
							client.put(res.path, file).then((r1) => {
								let url = this.montageResco(res.path)
								resolve(url);
							}).catch(err=>{
								reject(err);
							})
						}else{
							let endIndex = res.path.lastIndexOf('.');
							let path = res.path.slice(0,endIndex);
							resolve({client,path});
						}
					}else{
						reject(data.message || data.msg);
					}
				}).catch(err=>{
					reject(err);
				})
			}
			
		})
	},
	ImageParameterSplicing(data){ //图片路径过滤
		let {value, size, df, ignorePicPro } = data;
		if(!value) return df?df:'';
		let querystring, styleName='', isPicPro = !ignorePicPro && value.indexOf('picPro=1')>-1;
		if(/^blob:/.test(value)) return value;
		let supportDomains = [
			'ap-guangzhou.myqcloud.com', 
			'ap-hongkong.myqcloud.com'
		];
		let StartUp = localStorage.getItem('qx2StartUp');
		if (StartUp) {
			StartUp = JSON.parse(StartUp);
			sessionStorage.setItem('unstructuredSportDataHost', StartUp.configData.unstructuredSportDataHost);
			if (StartUp?.configData?.supportResStyleDomains && StartUp?.configData?.supportResStyleDomains?.length>0) {
				StartUp.configData.supportResStyleDomains.filter(e=>!supportDomains.find(s=>s == e)).forEach(e=>supportDomains.push(e));
			}
		}
		let spliceArr = [32,64,100,200,300,400,600,800,1000,2000];
		if (supportDomains.some(domain=>String(value).indexOf(domain)>-1)) {
			querystring = (value.split('?')[1]||"").split('&');
			value = value.split('?')[0];
			let imageMogr = '';
			let has = spliceArr.find((e,i,self)=>e <= size && self[i+1]?self[i+1]>size:true);
			if(has){
				imageMogr = `imageMogr2/thumbnail/${has}x${has}`;
			}
			if(size&&spliceArr.every(e=>e<size)){
				imageMogr = 'imageMogr2/thumbnail/2000x2000';
			}
			imageMogr&&querystring.push(imageMogr);
			
			return value + "?" + querystring.join("&") + "&" + new Date().getMinutes();
		}else{
			return value + "?" + new Date().getMinutes();
		}
	},
	imageError(item, parameter,imgname){
		console.log("图片加载失败",item, );
		console.log("图片加载失败",parameter);
		console.log("图片加载失败",imgname);
		if (item && imgname) {
			if (parameter) {
				item[parameter] = this.getExt(imgname);
			}else{
				item = this.getExt(imgname);
			}
		}
	},
	imgErr(e){
		e.target.src = defaultGroupChatAvatar;
	},
	getExt(relUrl){
		if(!relUrl)return null;
		if (relUrl&&relUrl.includes('http')) {
			return relUrl;
		}else{
			if(!/^\//.test(relUrl))relUrl='/'+relUrl;
			// return require(`@/assets${relUrl}`);
			let  _version = localStorage.getItem('qx2version');
			if (_version){
				let versionLocal = JSON.parse(_version);
				let version = versionLocal.version;
				if (version) {
					return `/assets${relUrl}?v=${version}`;
				}
			}
			return `/assets${relUrl}`;
		}
	},
	parsingEmoticons(str,emojiListView) {
		var fn = (str,startPoint=0) => {
			if (!emojiListView.length) return str;
			let str1 = (str??'').toString().split('');
			let leftIndex = -1;
			let rightIndex = -1;
			let i = 0;
			if(startPoint>0){
				i = startPoint;
			}
			for (; i < str1.length; i++) {
				if (leftIndex == -1) {
					// debugger
					if (str1[i] == '[') leftIndex = i;
				} else if (rightIndex == -1) {
					if (str1[i] == ']') {
						rightIndex = i;
						let _str1 = str1.join('');
						let s = _str1.slice(leftIndex + 1, rightIndex);
						let has = emojiListView.find(e => e.key == s);
						let _leftIndex = leftIndex;
						if (has) {
							let res = `<img src="${has.url}" class="emoticons_item" >`;
							str1.splice(leftIndex, rightIndex - leftIndex + 1, res);
							startPoint = 0;
							leftIndex = -1;
						}else{
							startPoint = rightIndex + 1;
						}
						// debugger
						if (i < str1.length - 1 + (_leftIndex + rightIndex)) {
							return fn(str1.join(''),startPoint);
						}
						break;
					}
				}
			}
			return str1.join('');
		}
		return fn(str);
	},
	tryIt(callback){
		return new Promise((resolve,reject)=>{
			try {
				if(typeof callback == 'function'){
					callback();
					resolve();
				}else if(typeof callback != 'function'){
					reject('callback:is not a funcction');
				}else if(callback == undefined){
					reject('callback:is undefined');
				}else{
					reject('callback:Unknown');
				}
			} catch (error) {
				reject(error);
			}
		})
	},

	/** 遍历多维对象数组
	* @param {string} childrenKey 子代元素的key
	* @param {string} key 数组的唯一关键字(如，id)
	*/
	multidimensionalObjectArray(){
		return class multidimensionalObjectArray {
			constructor(obj,opt={}){
				if (typeof obj != 'object') console.log('multidimensionalObjectArray的首位参数必须是数组或对象');
				let {childrenKey,key} = opt;
				this.obj=obj;
				this.childrenKey='list';
				if(childrenKey)this.childrenKey = childrenKey;
				this.key='id';
				if(key)this.key = key;
			}

			forEach(callback) {
				return this._each('forEach',{callback});
			}
			find(callback){
				return this._each('find',{callback});
			}
			_each(mode,{callback}){
				let result = (function eachData(obj,key,level,parent){
					if(level==undefined)level=0;
					else level++;
					if(typeof obj != 'object')return;
					for (var i in obj) {
						let item = obj[i];
						Object.assign(item,{_sourceIndex:item._index?item._index:i});
						Object.assign(item,{_index:i});

						let [path1,path2] = [item[key],item[key]];
						if(/\./.test(key)){
							let keyArr = key.split('.');
							path1 = item[keyArr[0]];
							path2 = keyArr[1]?(path1?path1[keyArr[1]]:path1):path1;
						}
						if(mode=='find'){
							Object.assign(item,{_level:level})
							let has;
							try{
								has = callback && callback(item,i,level,parent);
							}catch(err){
								throw new Error(err);
							}
							if(path1 && path2 && has){
								return item;
							}else{
								let _parent = Object.assign({},item);
								if(parent){
									_parent = Object.assign({},_parent,{_parent:parent});
								}
								let result = item && eachData.call(this,item[this.childrenKey],key,level,_parent);
								if(result){
									return result;
								}
							}
						}else if(mode=='forEach'){
							let _parent = Object.assign({},item);
							if(parent){
								_parent = Object.assign({},_parent,{_parent:parent});
							}
							try{
								callback&&callback(item,i,level,_parent);
							}catch(err){
								throw new Error(err);
							}
							eachData.call(this,item[this.childrenKey],key,level,_parent);
						}
					}
				}).call(this,this.obj,this.key);
				return result;
			}
		}
	},	


// 	uniqueGuid(id,list){
// 		if(!id||!list||!list.length) return id;
// 		let has = list.find(e=>e == id);
// 		return has?this.uniqueGuid(this.newGuid(),list):id;
// 	},

	//节流函数
	throttle(fun, delay, time) {
		var timeout,
			startTime = new Date();
		return function () {
			var context = this,
				args = arguments,
				curTime = new Date();
			clearTimeout(timeout);
			// 如果达到了规定的触发时间间隔，触发 handler
			if (curTime - startTime >= time) {
				fun.apply(context, args);
				startTime = curTime;
				// 没达到触发间隔，重新设定定时器
			} else {
				timeout = setTimeout(()=> {
					fun.apply(context, args);
				}, delay);
			}
		}
	},
	// 防抖函数
	debounce(callback, delay = 300) {
		let timer;
		let lastExc = 0;
		return function() {
		  let context = this; // 这边的 this 指向谁?
		  let args = arguments; // arguments中存着e
		  
		  let callNow = ()=>{
			  lastExc = new Date().getTime();
			  callback.apply(context, args);
		  }
		  var nextExcDelay = lastExc + delay - new Date().getTime();
		  if(timer) clearTimeout(timer);
		  if (nextExcDelay > 0) {
			// console.log("发起等待：" + nextExcDelay);
			timer = setTimeout(() => {
				timer = null;
				callNow();
			}, nextExcDelay);
		  }else{
			  console.log("无等待任务，立即执行");
			  callNow();
		  }
		}
	},

// 	// 获取球衣颜色
// 	getClothesColor(val) {
// 		const ClothesColor = Constant.ClothesColor.find(e=>e.value==val);
// 		return ClothesColor?ClothesColor.color:'';
// 	},
// 	// 根据球衣颜色改变队名字体颜色
// 	getTeamNameColor(color){
// 		const ClothesColor = Constant.ClothesColor;
// 		ClothesColor.push({value: null, label: '暗蓝色', color: '#355CA8'},{value: null, label: '暗红色', color: '#8d2429'});//篮球比分条2的默认色
// 		let textColor = '#fff';
// 		let hascolor = ClothesColor.find(e=>e.color == color);
// 		if(hascolor){
// 			if([2, 3, 4, 6, 7, 8, 9, 10, 12, 13, 15, 16].some(s=>hascolor.value == s)){
// 				textColor = '#fff';
// 			}else if([1, 3, 5, 11, 14, 18, 20, 36, 38].some(s=>hascolor.value == s)){
// 				textColor = '#000';
// 			}
// 		}
// 		return textColor;
// 	},
	clearObject(obj) {
		Object.keys(obj).forEach((key)=>delete obj[key]);
	},
	objectToParamStr(obj){
		return Object.keys(obj).map(k=>`${k}=${obj[k]}`).join('&');
	},
// 	// 区间随机数
// 	intervalRandom(min,max){
// 		let temp;
// 		if(min>max){
// 			temp=max;max=min;min=temp;
// 		}
// 		return Math.floor(Math.random() * (max - min) ) + min;
// 	},
// 	tryloadImg(target,url,reloadTime){
// 		// #ifndef MP
// 		if(!url)return;
// 		let random = this.intervalRandom(1000,9999),
// 			time = (+new Date()).toString().substr(-6);
// 		let _url = url.split('?')[0];
// 		let params = url.split('?')[1];
// 		let paramsArr = [];
// 		if(params){//如果存在参数则将参数取出来
// 			paramsArr = params.split('&').map(e=>{
// 				let key = e.split('=')[0];
// 				let val = e.split('=')[1];
// 				return {key,val}
// 			})
// 		}
// 		let has = paramsArr.find(e=>e.key == 'try');
// 		if(has){
// 			has.val = `${time}${random}`;
// 		}else{
// 			paramsArr.push({
// 				key:'try',
// 				val:`${time}${random}`,
// 			})
// 		}
// 		url = `${_url}?${paramsArr.map(e=>e.key + '=' + e.val).join('&')}`;
// 		const img = new Image();
// 		img.src = url;
// 		img.onload = ()=>{
// 			target.src = url;
// 		}
// 		img.onerror = ()=>{ //加载失败n秒后重试
// 			reloadTime&&this.awaitTime(reloadTime,()=>this.tryloadImg(target,url,reloadTime));
// 		}
// 		// #endif
// 	},
	awaitTime(time,cb,opt={}){
		return new Promise((resolve,reject)=>{
			try{
				opt.timer = setTimeout(()=>{
					cb&&cb();
					resolve();
				},time)
				setTimeout(()=>reject('退出了awaitTime'),time);
			}catch(err){
				reject(err);
			}
		})
	},
	filterDate(value, type){
		if(value && String(value).trim()!='' && value!=null && value!=undefined){
			if(type=='YMDd'){
				return moment(value).format("YYYY年MM月DD日 星期")+['一','二','三','四','五','六','日'][moment(value).weekday()]
			}
			if(type=='周Hm'){
				return moment(value).format("周")+['一','二','三','四','五','六','日'][moment(value).weekday()]+' '+moment(value).format("HH:mm");
			}
			if(type=='week'){
				return moment(value).format("星期")+['一','二','三','四','五','六','天'][moment(value).weekday()];
			}
			if(type=='Week'){
				return moment(value).format("周")+['一','二','三','四','五','六','日'][moment(value).weekday()];
			}
			if(type=='Y'){
				return moment(value).format("YYYY");
			}
			if(type=='YMDHms'){
				return moment(value).format("YYYY-MM-DD HH:mm:ss");
			}
			if(type=='YMDHm'){
				return moment(value).format("YYYY-MM-DD HH:mm");
			}
			if(type=='CYMD'){
				return moment(value).format("YYYY年MM月DD日");
			}
			if(type=='YMD'){
				return moment(value).format("YYYY-MM-DD");
			}
			if(type=='YMD/'){
				return moment(value).format("YYYY/MM/DD");
			}
			if(type=='ymdHm'){
				return moment(value).format("YYYY.MM.DD HH:mm");
			}
			if(type=='ymd'){
				return moment(value).format("YYYY.MM.DD");
			}
			if(type=='YM'){
				return moment(value).format("YYYY-MM");
			}
			if(type=='ym'){
				return moment(value).format("YYYY.MM");
			}
			if(type=='MDHm'){
				return moment(value).format("MM-DD HH:mm");
			}
			if(type=='M/DHm'){
				return moment(value).format("MM/DD HH:mm");
			}
			if(type=='CMDHm'){
				return moment(value).format("MM月DD日 HH:mm");
			}
			if(type=='CMD'){
				return moment(value).format("MM月DD日");
			}
			if(type=='MD'){
				return moment(value).format("MM-DD");
			}
			if(type=='M/D'){
				return moment(value).format("MM/DD");
			}
			if(type=='Hm'){
				return moment(value).format("HH:mm");
			}
			if(type == 'CYMDHM'){
				return moment(value).format('YYYY年MM月DD日 HH:mm')  
			}
			if(type == 'dayzh'){
				return moment(value).calendar(null, {
					sameDay: '[今天]',
					nextDay: '[明天]',
					lastDay: '[昨天]',
					nextWeek: ' ',
					lastWeek: ' ',
					sameElse: ' '
				})
			}
			if(type == 'dayzhMD'){
				return moment(value).calendar(null, {
					sameDay: '[今天]',
					nextDay: '[明天]',
					lastDay: '[昨天]',
					nextWeek: 'MM-DD',
					lastWeek: 'MM-DD',
					sameElse: 'MM-DD'
				})
			}
			if(type == 'dayHm'){
				return moment(value).calendar(null, {
					sameDay: '[今天] HH:mm',
					nextDay: '[明天] HH:mm',
					nextWeek: 'MM-DD HH:mm',
					lastDay: '[昨天] HH:mm',
					lastWeek: 'MM-DD HH:mm',
					sameElse: 'MM-DD HH:mm'
				})
			}
			if(type == 'dayYHm'){
				return moment(value).calendar(null, {
					sameDay: '[今天] HH:mm',
					nextDay: '[明天] HH:mm',
					nextWeek: 'YYYY-MM-DD HH:mm',
					lastDay: '[昨天] HH:mm',
					lastWeek: 'YYYY-MM-DD HH:mm',
					sameElse: 'YYYY-MM-DD HH:mm'
				})
			}
			if(type == 'dayorHm'){
				return moment(value).calendar(null, {
					sameDay: 'HH:mm',
					nextDay: 'HH:mm',
					nextWeek: 'MM-DD',
					lastDay: '[昨天]',
					lastWeek: 'MM-DD',
					sameElse: 'MM-DD'
				})
			}
		}else{
			return value='';
		}
	},
	//重试函数
	//fun：需要得到的保证
	reTry(fun, maxTimes, delay) {
		return new Promise((resolve, reject)=> {
			var attempt = ()=> {
				fun().then(resolve).catch((erro)=> {
					console.log(`还有 ${maxTimes} 次尝试`)
					if (0 == maxTimes) {
						reject(erro)
					} else {
						maxTimes--
						setTimeout(attempt, delay)
					}
				})
			}
			attempt()
		})
	},
	deepClone() {
		// 定义一个变量
		let result, source;
		if (arguments.length == 0) return {};
		else if (arguments.length == 1) {
			source = arguments[0]
		} else if (arguments.length == 2) {
			result = arguments[0];
			source = arguments[1]
		} else {
			arguments.reduceRight((target, source) => this.deepClone(target, source))
		}
		// 如果当前需要深拷贝的是一个对象的话
		if (typeof source == 'object') {
			// 如果是一个数组的话
			if (Array.isArray(source)) {
				result = result || []; // 将result赋值为一个数组，并且执行遍历
				result.splice(0, result.length)
				for (let i in source) {
					// 递归克隆数组中的每一项
					result.push(this.deepClone(source[i]))
				}
				// 判断如果当前的值是null的话；直接赋值为null
			} else if (source == null) {
				result = null;
				// 判断如果当前的值是一个RegExp对象的话，直接赋值
			} else if (source.constructor == RegExp) {
				result = result || source;
			} else {
				// 否则是普通对象，直接for in循环，递归赋值对象的所有值
				result = result || {};
				for (let i in source) {
					result[i] = this.deepClone(result[i], source[i]);
				}
			}
			// 如果不是对象的话，就是基本数据类型，那么直接赋值
		} else {
			result = source;
		}
		// 返回最终结果
		return result;
	},
// 	isWechat() {
// 		let value = false;
// 		try {
// 			// #ifdef MP
// 			const { hostName } = uni.getAppBaseInfo();
// 			value = /WeChat/i.test(hostName); 
// 			// #endif
// 			// #ifndef MP
// 			const userAgent = navigator.userAgent.toLowerCase(); 
// 			value = userAgent.indexOf('micromessenger') !== -1;
// 			// #endif
// 		} catch (error) {
// 			value = false;
// 		}
// 		return value;
// 	},
// 	isIOS() {
// 		// #ifdef MP-WEIXIN
// 		const { system } = uni.getDeviceInfo();
// 		// #endif
// 		// #ifndef MP-WEIXIN
// 		const { system } = uni.getSystemInfoSync();
// 		// #endif
// 		return /ios/i.test(system);
// 	},
// 	isAndroid() {
// 		// #ifdef MP-WEIXIN
// 		const { system } = uni.getDeviceInfo();
// 		// #endif
// 		// #ifndef MP-WEIXIN
// 		const { system } = uni.getSystemInfoSync();
// 		// #endif
// 		return /android/i.test(system);
// 	},
// 	// 获取篮球第几节
// 	getCurrentQuarter(status){
// 		let currentQuarter=0
// 		let currentQuarterOver=0
// 		switch(status){
// 			// 获得当前第几节
// 			case 1:
// 			currentQuarter=1;
// 			break;
// 			case 3:
// 			currentQuarter=2;
// 			break;
// 			case 5:
// 			currentQuarter=3;
// 			break;
// 			case 7:
// 			currentQuarter=4;
// 			break;
// 			case 10:
// 			currentQuarter=5;
// 			break;
// 			// 获得当前第几节结束
// 			case 2:
// 			currentQuarterOver=1;
// 			break;
// 			case 4:
// 			currentQuarterOver=2;
// 			break;
// 			case 6:
// 			currentQuarterOver=3;
// 			break;
// 			case 8:
// 			currentQuarterOver=4;
// 			break;
// 			case 9:
// 			case 11:
// 			currentQuarterOver=5;
// 			break;
// 		}
// 		return {currentQuarter,currentQuarterOver}
// 	},
	/**
	 * 比赛状态判断
	 * @param {string} type - 比赛状态
	 * @param {object} match - 比赛数据
	 */
	matchStatusfunction(type, match, sportType){
		if (sportType||sportType==0) {
			match['sportType'] = sportType;
		}
		if (!match.status && match.matchState>=0) {
			match['status'] = match.matchState;
		}
		if (type=='NotStarted') { //未开始
			if (match.status && match.status>=0) {
				if (match.sportType==0) {
					return [0, 17].indexOf(match.status)>-1;
				}
				if (match.sportType==1) {
					return [0].indexOf(match.status)>-1;
				}
				if (match.sportType>1) {
					return [0].indexOf(match.status)>-1;
				}
			}else{
				return [0].indexOf(match.matchStatus)>-1;
			}
		}
		if (type=='InProgress') { //进行中
			if (match.status) {
				let matching = [];
				if (match.sportType==0) {
					matching = [1, 2, 3, 7, 8, 9, 11, 16, 20];
				}
				if (match.sportType==1) {
					matching = [1, 2, 3, 4, 5, 6, 7, 8, 10];
				}
				if (match.sportType>1) {
					matching = [1, 3];
				}
				return matching.indexOf(match.status)>-1;
			}else{
				return [1].indexOf(match.matchStatus)>-1;
			}
		}
		if (type=='Finish') { //结束
			if (match.status) {
				let finish = [];
				if (match.sportType==0) {
					finish = [4, 5, 6, 10, 12, 14, 15, 18, 19];
				}
				if (match.sportType==1) {
					finish = [9, 11, 12, 13, 15, 16, 17, 18];
				}
				if (match.sportType>1) {
					finish = [2, 9];
				}
				return finish.indexOf(match.status)>-1;
			}else{
				return [2].indexOf(match.matchStatus)>-1;
			}
		}
		if (type=='Unexpected') { //意外
			if (match.status) {
				let unexpected = [];
				if (match.sportType==0) {
					unexpected = [5, 6, 13, 14, 15, 18];
				}
				if (match.sportType==1) {
					unexpected = [12, 13, 14, 15, 16, 17];
				}
				if (match.sportType>1) {
					unexpected = [4, 5, 6, 7, 8];
				}
				return unexpected.indexOf(match.status)>-1;
			}else{
				return [3].indexOf(match.matchStatus)>-1;
			}
		}
		if (type=='Showtwinkle') { //读秒
			if (match.status) {
				if (match.sportType==0) {
					return [1,3].indexOf(match.status)>-1;
				}
				if (match.sportType==1) {
					return [1,3,5,7,10].indexOf(match.status)>-1;
				}
				if (match.sportType>1) {
					return [1,3].indexOf(match.status)>-1;
				}
			}else{
				return false;
			}
		}
		if (type=='Delay') { //延期
			if (match.status) {
				if (match.sportType==0) {
					return [13].indexOf(match.status)>-1;
				}
				if (match.sportType==1) {
					return [14].indexOf(match.status)>-1;
				}
				if (match.sportType>1) {
					return [6].indexOf(match.status)>-1;
				}
			}else{
				return [3].indexOf(match.matchStatus)>-1;
			}
		}
		if (type=='Waiver') { //弃权
			if (match.status) {
				if (match.sportType==0) {
					return [19].indexOf(match.status)>-1;
				}
				if (match.sportType==1) {
					return [18].indexOf(match.status)>-1;
				}
				if (match.sportType>1) {
					return [9].indexOf(match.status)>-1;
				}
			}else{
				return false;
			}
		}
	},
	getRandom(list){
		console.log('调用了随机函数',list)
		//随机返回一个数组中的元素
		return list[Math.floor(Math.random()*list.length)]
	},
	//强加好友函数，
	isForceFriendAdd(){
		let UserInfo = localStorage.getItem('qx2userInfo');
		if (UserInfo) {
			let permissions = JSON.parse(UserInfo).permissions;
			if (permissions && permissions.includes('ForceFriendAdd')) {
				return true;
			} else {
				return false;  // 有用户信息但没权限
			}
		} else {
			return false;  // 没用户信息
		}
	},
	//用户身份匹配
	userType(identityFlagsList){
		let StartUp = localStorage.getItem('qx2StartUp');
		if (StartUp) {
			let nameCardDisplayNames = JSON.parse(StartUp)?.nameCardDisplayNames;
			// nameCardDisplayNames 示例: ["黄钻", "红钻", "蓝钻"]
			// 如果没有传入 identityFlagsList，从用户信息中获取
			// if (!identityFlagsList) {
			// 	let UserInfo = localStorage.getItem('qx2userInfo');
			// 	if (UserInfo) {
			// 		identityFlagsList = JSON.parse(UserInfo).identityFlagsList;
			// 	} else {
			// 		return [];
			// 	}
			// }
			// 传入的是数组，直接按索引取值
			return identityFlagsList
				.filter(index => index >= 0 && index < nameCardDisplayNames.length)
				.map(index => nameCardDisplayNames[index]);
		}
		return [];
	},
	//解析二进制
	parseRoleToIdentityFlagsList(role){
		let identityFlagsList = [];
		let index = 0;  // 从下标0开始
		
		while (role > 0) {
			if (role & 1) {  // 检查最低位是否为1
				identityFlagsList.push(index);  // 推入下标值
			}
			role >>= 1;      // 右移一位
			index++;         // 下标加1
		}
		
		return identityFlagsList;
	},
	//选择背景颜色
	getBgColor(index){
	    let colorList = [
			'#F9A825',
			'#E53935',
			'#1E88E5',
			'#43A047',
			'#FB8C00',
			'#8E24AA',
			'#3949AB',
			'#D81B60'
		  ];
		  return colorList[index % colorList.length];
	},
	/**
	 * 比赛状态判断
	 * @param {string} sportType - 比赛类型
	 * @param {object} status - 枚举值
	 * @param {object} quarters - 共有节数
	 * @param {object} otQuarter - 加时数
	 */
	statusTurnmatchStatus(match){
		let sportType = match.sportType||0; 
		let quarters = match.quarters||0; 
		let otQuarter = match.otQuarter||0;
		if (sportType>1) sportType = 2;
		let footBallStatusObj = {type:0,statusarr:[
			{value:0,status:0,matchStatus:0,label:"未开始"},
			{value:1,status:1,matchStatus:1,label:"上半场"},
			{value:2,status:2,matchStatus:1,label:"中场"},
			{value:3,status:3,matchStatus:1,label:"下半场"},
			{value:4,status:4,matchStatus:2,label:"完场"},
			{value:5,status:5,matchStatus:3,label:"中断"},
			// {value:6,status:6,matchStatus:3,label:"取消"},
			{value:7,status:7,matchStatus:1,label:"加时"},
			{value:8,status:8,matchStatus:1,label:"加时上"},
			{value:9,status:9,matchStatus:1,label:"加时下"},
			{value:10,status:10,matchStatus:2,label:"完场"},
			{value:11,status:11,matchStatus:1,label:"点球"},
			{value:12,status:12,matchStatus:2,label:"完场"},
			{value:13,status:13,matchStatus:3,label:"延期"},
			// {value:14,status:14,matchStatus:3,label:"腰斩"},
			{value:15,status:15,matchStatus:3,label:"待定"},
			{value:16,status:16,matchStatus:1,label:"金球"},
			{value:17,status:17,matchStatus:0,label:"未开始"},
			// {value:18,status:18,matchStatus:3,label:"比赛异常"},
			// {value:19,status:19,matchStatus:2,label:"弃权"},
			{value:20,status:20,matchStatus:1,label:"暂停"}
		]}
		let basketBallStatusObj = { type: 1, statusarr: [
			{value:0,status:0,matchStatus:0,label:"未开始"},
			{value:1,status:1,matchStatus:1,label:"第一节"},
			{value:2,status:2,matchStatus:1,label:"第一节完"},
			{value:3,status:3,matchStatus:1,label:"第二节"},
			{value:4,status:4,matchStatus:1,label:"第二节完"},
			{value:5,status:5,matchStatus:1,label:"第三节"},
			{value:6,status:6,matchStatus:1,label:"第三节完"},
			{value:7,status:7,matchStatus:1,label:"第四节"},
			{value:8,status:8,matchStatus:1,label:"第四节完"},
			{value:9,status:9,matchStatus:2,label:"完场"},
			{value:10,status:10,matchStatus:1,label:"加时"},
			{value:11,status:11,matchStatus:2,label:"加时完"},
			{value:12,status:12,matchStatus:3,label:"中断"},
			// {value:13,status:13,matchStatus:3,label:"取消"},
			{value:14,status:14,matchStatus:3,label:"延期"},
			// {value:15,status:15,matchStatus:3,label:"腰斩"},
			{value:16,status:16,matchStatus:3,label:"待定"},
			// {value:17,status:17,matchStatus:3,label:"比赛异常"},
			// {value:18,status:18,matchStatus:2,label:"弃权"}
		]}
		let RoundMatchStatusObj = { type: 2, statusarr: [
			{value:0,status:0,matchStatus:0,label:"未开始"},
			{value:1,status:1,matchStatus:1,label:"进行中"},
			{value:2,status:2,matchStatus:2,label:"完赛"},
			{value:3,status:3,matchStatus:1,label:"赛点"},
			{value:4,status:4,matchStatus:3,label:"中断"},
			// {value:5,status:5,matchStatus:3,label:"取消"},
			{value:6,status:6,matchStatus:3,label:"延期"},
			// {value:7,status:7,matchStatus:3,label:"腰斩"},
			{value:8,status:8,matchStatus:3,label:"待定"},
			// {value:9,status:9,matchStatus:2,label:"弃权"}
		]}
		let statusArr = [{...footBallStatusObj}, {...basketBallStatusObj}, {...RoundMatchStatusObj}];
		let statusObj = statusArr.find(item => item.type == sportType);
		let matchStatusarr = [];
		if (statusObj) {matchStatusarr = statusObj.statusarr;} 
		else { console.log(`找不到对应的体育类型"${sportType}",请检查传参是否正确`); }

		let stata = matchStatusarr.find(item => item.value == match._status);
		let label='-';
		if (stata) {
			if (match._key=='label' || match._key=='quarters') {
				if((sportType==1 && match._status==10) && otQuarter && otQuarter>=1){
					return label = '加时'+otQuarter;
				}
				if((sportType==1 && match._status==11) && otQuarter && otQuarter>=1){
					return label = '加时'+otQuarter+'完';
				}
			}
			if (match._key=='label') {
				label = stata.label;
			} else if (match._key=='quarters') {
				if (sportType==0) {
					label = stata.label;
				}else if ( sportType==1 ) { //篮球
					switch (quarters) {
						case 1:    //共有节数1
							if (match._status == 1) {
								label = "进行中"
							} else if (match._status == 2) {
								label = "常规时间结束"
							} else {
								label = stata.label;
							}
							break;
						case 2:    //共有节数2
							if (match._status == 1) {
								label = "上半场"
							} else if (match._status == 2) {
								label = "上半场结束"
							}else if (match._status == 3) {
								label = "下半场"
							}else if (match._status == 4) {
								label = "下半场结束"
							} else {
								label = stata.label;
							}
							break;
						default:
							label = stata.label;
							break;
					}
				}else if ( sportType==2 ) { //其他球类
					if (match._status==1) {
						label = `${'第'+ (quarters || 1) +'局 进行中'}`
					}else if (match._status==2) {
						label = `完赛`
					}else{
						label = stata.label;
					}
				}
			} else{
				label = stata.matchStatus;
			}
		}
		return label;
	},
	matchStateLabel(match){
		Object.assign(match,{_key:'quarters', _status: match.status})
		return this.statusTurnmatchStatus(match);
	},
}
